<api-error-alert
[apiError]="error$ | async"
(resetError)="resetError()"
[closable]="true"></api-error-alert>
